import { render, staticRenderFns } from "./project-type-3.html?vue&type=template&id=c0ef1632&scoped=true&external"
import script from "./project-type-3.js?vue&type=script&lang=js&external"
export * from "./project-type-3.js?vue&type=script&lang=js&external"
import style0 from "./project-type-3.scss?vue&type=style&index=0&id=c0ef1632&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ef1632",
  null
  
)

export default component.exports